import { createApp } from 'vue';
import axios from 'axios';

const newsletterSignupForm = async () => {
    const formElement = document.querySelector('#newsletterSignupForm');

    if (!formElement) {
        return;
    }

    const app = createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                email: null,
                hfirstName: null,
                success: false,
                failed: false,
                message: null
            };
        },
        methods: {
            onSubmit() {
                const endpoint = '/actions/groupfirst/api/subscribe-newsletter';
                const params = this.getCsrfAwareParams();

                axios.post(endpoint, params)
                    .then((res) => {
                        this.success = true;
                    })
                    .catch((error) => {
                        this.failed = true;
                        this.message = error.response.data.message;
                    });
            },
            getCsrfAwareParams() {
                const params = new URLSearchParams();

                params.append(window.csrfTokenName, window.csrfTokenValue);
                params.append('hfirstName', this.hfirstName);
                params.append('email', this.email);

                return params;
            }
        },
        mounted() {
            formElement.classList.add('show');
        }
    });

    app.mount(formElement);
};

export default newsletterSignupForm;
